/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

import { TUTORIAL_IDS } from "@/shared";
import { useDrawerStore } from "@/stores/useDrawerStore";

import { colors, MenuIcon } from "@dotnet/telematics-design-system";

import Button from "../Button/Button";
import useTutorialMode from "../TutorialMode/hooks/useTutorialMode";
import { STEP_GROUP } from "../TutorialMode/types";

const MobileMenuButton = () => {
  const { checkIfCorrectTutorialStep, callTutorialWithTimeout } =
    useTutorialMode();

  const { setIsMobileDrawerOpen } = useDrawerStore();

  const handleOpenDrawer = () => {
    setIsMobileDrawerOpen(true);

    if (checkIfCorrectTutorialStep(STEP_GROUP.TutorialNewCompanyCard, 0)) {
      callTutorialWithTimeout(
        true,
        1,
        STEP_GROUP.TutorialNewCompanyCard,
        true,
        500
      );
    }

    if (checkIfCorrectTutorialStep(STEP_GROUP.TutorialCreateSchedule, 1)) {
      callTutorialWithTimeout(
        true,
        2,
        STEP_GROUP.TutorialCreateSchedule,
        true,
        500
      );
    }

    if (checkIfCorrectTutorialStep(STEP_GROUP.TutorialApplySchedule, 0)) {
      callTutorialWithTimeout(
        true,
        1,
        STEP_GROUP.TutorialApplySchedule,
        true,
        500
      );
    }
  };

  return (
    <Button
      data-testid={TUTORIAL_IDS.MobileDrawerButton}
      id={TUTORIAL_IDS.MobileDrawerButton}
      variant="iconOnly"
      size="small"
      color="white"
      icon={<MenuIcon css={css({ color: colors.textDark })} />}
      onClick={handleOpenDrawer}
      css={css({ marginLeft: "4px" })}
    />
  );
};

export default MobileMenuButton;
